import React from 'react';

const Breadcrumb = ({ path, onNavigate }) => {
  return (
    <div>
      {path.map((nivel, index) => (
        <span key={index} onClick={() => onNavigate(index)}>
          {nivel} {index < path.length - 1 && '>'}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumb;
